import { variablesGlobales } from "../../configs/variables";

/* This example requires Tailwind CSS v2.0+ */
const navigation = {
  support: [
    { name: "Ingresar a mi cuenta", href: "/ingresar" },
    { name: "Pagar mi cuota", href: "/pagos" },
    { name: "Contáctanos", href: "/contactanos" },
    { name: "Preguntas frecuentes", href: "/faqs" },
  ],
  company: [
    { name: "Nosotros", href: "/nosotros" },
    { name: "Blog", href: "/blog" },
    { name: "Cómo funciona", href: "/como-funciona" },
    { name: "Tasas y tarifas", href: "/tarifas" },
  ],
  legal: [
    {
      name: "Tratamiento de datos personales",
      href: variablesGlobales.policyData,
    },
    { name: "Terminos y condiciones", href: "/terminos" },
    {
      name: "Contrato",
      href: "/pdf/v2.contrato_credito_bajo_monto.pdf",
      download: "Contrato crédito de bajo monto Galilea",
    },
  ],
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/galileafintech",
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/galileafintech/",
      icon: (props) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],
};

export function Footer() {
  return (
    <footer className="bg-white text-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:flex justify-between">
          <div className="min-w-24 grid justify-items-center space-y-8">
            <a href="/">
              <img
                className="h-24 w-24"
                src="/svg/imagotipo-galilea-19.svg"
                alt="Company name"
              />
            </a>
            <p className="text-white text-base"></p>
          </div>
          <div className="w-full flex justify-center mt-12 gap-8 xl:mt-0 pb-12">
            <div className="w-full max-w-3xl">
              <div className="lg:flex gap-4 justify-between">
                <div className="w-full">
                  <h3 className="grid justify-items-center lg:justify-items-start pb-6 pt-6 lg:pt-0 text-xl font-bold text-grayP tracking-tight ">
                    Galilea Fintech
                  </h3>
                  <ul className="mt-4 space-y-4">
                    {navigation.company.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          className="grid justify-items-center lg:justify-items-start text-base font-bold text-tdark hover:text-grayP transition-colors"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="w-full">
                  <h3 className="grid justify-items-center lg:justify-items-start pb-6 pt-6 lg:pt-0 text-xl font-bold text-grayP tracking-tight ">
                    Soporte
                  </h3>
                  <ul className="mt-4 space-y-4">
                    {navigation.support.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          className="grid justify-items-center lg:justify-items-start text-base font-bold text-tdark hover:text-grayP transition-colors"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="w-full">
                  <h3 className="grid justify-items-center lg:justify-items-start pb-6 pt-6 lg:pt-0 text-xl font-bold text-grayP tracking-tight ">
                    Legal
                  </h3>
                  <ul className="mt-4 space-y-4">
                    {navigation.legal.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          target={
                            item.name === "Tratamiento de datos personales"
                              ? "_blank"
                              : undefined
                          }
                          rel={
                            item.name === "Tratamiento de datos personales"
                              ? "noopener noreferrer"
                              : undefined
                          }
                          className="grid justify-items-center lg:justify-items-start  text-base font-bold text-tdark hover:text-grayP transition-colors"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="grid justify-items-center pt-4 xl:pt-0">
            <div className="flex space-x-1 max-h-20">
              {navigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className=" bg-grayM px-6 py-6 hover:bg-purple"
                >
                  <span className="text-tdark">
                    <span className="sr-only">{item.name}</span>
                    <item.icon className="h-8 w-auto" aria-hidden="true" />
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="xl:flex mt-12 border-t border-grayP pt-14">
          <div className="py-14 grid content-center text-base text-grayP text-left">
            &copy; 2022 Galilea, todos los derechos reservados. Galilea es una
            marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA registrada en Colombia
            con NIT: 901.582.748-5. Edificio Sibelius, Vereda Fagua,
            Sector La Caro, Autopista Norte, Chía, Cundinamarca, correo
            electrónico ayuda@galilea.co. Hacer uso de nuestro sitio web implica
            la aceptación de nuestros términos y condiciones así como el
            tratamiento de datos personales dispuestos en https://galilea.co
          </div>
          <div className="flex items-center w-full">
            <div className="grid content-center h-full justify-items-center xl:justify-items-end w-full">
              <a href="https://www.colombiafintech.co">
                <img className="w-48" src="/png/cf.png" alt="cf" />
              </a>
            </div>
            <div className="grid content-center h-full justify-items-center xl:justify-items-end w-full">
              <a className="h-full" href="https://sedeelectronica.sic.gov.co/">
                <img className="w-48" src="/png/sic.png" alt="sic" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
